import { differenceInDays as p } from "../../../node_modules/date-fns/differenceInDays.mjs";
const m = (f, r, o) => (f && r && p(r, f) > o && (f = new Date(r.getTime() - o * 24 * 60 * 60 * 1e3)), [f, r]);
export {
  m as applyMaxInterval
};
